import React, { useState } from "react";
import { service_insurance } from "../../../data/servicesData";

const CyberTabPage = () => {
  const [data] = useState(service_insurance?.cyber || {});
  return (
    <div className="text-left space-y-6">
      <div className="space-y-2">
        {data.overview.map((item, index) => (
          <div key={index}>
            <span>{item}</span>
          </div>
        ))}
      </div>
      <div className="space-y-2">
        <h1 className="font-bold">{data.title}</h1>
        <div className="space-y-2">
          {data.items.map((item, index) => (
            <div key={index}>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
      {/* items button */}
      <div className="space-y-2">
        <div className="flex flex-wrap gap-4 sm:space-y-0">
          {data.items_button.map((item, index) => (
            <div
              key={index}
              className="bg-yellow rounded font-bold text-blue-gray-800 p-6 flex-1 min-w-[200px] sm:basis-[calc(50%-1rem)] lg:basis-[calc(33.333%-1rem)] text-center"
            >
              <span>{item}</span>
            </div>
          ))}
        </div>
        <h1>{data.sub_title}</h1>
      </div>

      {/* items button */}
      <div className="space-y-2">
        <h1 className="font-bold">{data.title1}</h1>
        <div className="flex flex-wrap gap-4 sm:space-y-0">
          {data.items1_button.map((item, index) => (
            <div
              key={index}
              className="bg-yellow rounded font-bold text-blue-gray-800 p-6 flex-1 min-w-[200px] sm:basis-[calc(50%-1rem)] lg:basis-[calc(33.333%-1rem)] text-center"
            >
              <span>{item}</span>
            </div>
          ))}
        </div>
        <h1>{data.sub_title1}</h1>
      </div>

      <div className="space-y-2">
        <h1 className="font-bold">{data.title2}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.items2.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="space-y-2">
        <h1 className="font-bold">{data.title3}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.items3.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CyberTabPage;
